import { render, staticRenderFns } from "./PaymentWorkflowFilterModal.vue?vue&type=template&id=98c23470"
import script from "./PaymentWorkflowFilterModal.vue?vue&type=script&lang=ts"
export * from "./PaymentWorkflowFilterModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports